import { API_ROUTE_REPLACE_COMPANY_KEY, ApiRouteKeys } from '@constants/api-routes.constant';

export enum BillingApiRouteKeys {
  clientGeneralLedgerRecords = 'client_general_ledger_records'
}

export const BILLING_API_ROUTE_BASE = 'api/v1/billing';
export const BILLING_COMPANY_API_ROUTE_BASE = `${BILLING_API_ROUTE_BASE}/${ApiRouteKeys.companies}/${API_ROUTE_REPLACE_COMPANY_KEY}`;

export const BILLING_API_ROUTES = {
  companyClientGeneralLedgerRecords: `${BILLING_COMPANY_API_ROUTE_BASE}/${BillingApiRouteKeys.clientGeneralLedgerRecords}`
};
